import React from 'react';

import HeaderContainer from 'containers/HeaderContainer';
import RedeemHistoryContainer from 'containers/RedeemHistoryContainer';
import Footer from 'views/Footer';

class RedeemHistoryPage extends React.Component {

	render() {
		return (<div>
			        <HeaderContainer />
			        <RedeemHistoryContainer />
			        <Footer />
		      	</div>
			);
		
	}
}

export default RedeemHistoryPage;


// WEBPACK FOOTER //
// ./src/pages/RedeemHistoryPage.js